import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ActivityFilters } from '../../../commons/models/activity.model';

@Component({
  selector: 'app-activity-filters',
  templateUrl: './activity-filters.component.html',
  styleUrls: ['./activity-filters.component.scss']
})
export class ActivityFiltersComponent {
  @Output()
  onFilter: EventEmitter<ActivityFilters> = new EventEmitter();

  private _defaultFilters: ActivityFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
      start: "",
      end: "",
      client: "",
      payable: "",
      billable: "",
      project: "",
      head_project: "",
      validated: "",
      professional: "",
      promo: "",
      client_invoice_id: "",
      professional_invoice_id: "",
      accounted: ""
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getActivityFilters());
  }

  private _getActivityFilters(): ActivityFilters {
    let filters: ActivityFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
      filters.start = values.start;
      filters.end = values.end;
      filters.client_id = values.client?.id;
      filters.payable = values.payable;
      filters.validated = values.validated;
      filters.billable = values.billable;
      filters.promo = values.promo;
      filters.project_id = values.project?.id;
      filters.head_project_id = values.head_project?.id
      filters.professional = values.professional;
      filters.client_invoice_id = values.client_invoice_id;
      filters.professional_invoice_id = values.professional_invoice_id;
      filters.accounted = values.accounted;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
      start: "",
      end: "",
      client: "",
      payable: null,
      billable: null,
      promo: null,
      project: "",
      head_project: "",
      validated: "",
      professional: "",
      client_invoice_id: "",
      professional_invoice_id: "",
      accounted: ""
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): ActivityFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: ActivityFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue(this.defaultFilters);
      }
    }
  }
}
